import { brandedOperator, operatorKey } from './theme';

export const SUBSCRIPTIONS_PATH = '/suscripciones';

export const OPERATOR_DETAIL_ROUTE = `${SUBSCRIPTIONS_PATH}/:product/:operator`;

export const PRODUCTS = {
    watch: {
        label: 'Relojes',
        slug: 'relojes',
        icon: '/images/cs-watchIconSearch.svg',
    },
    tablet: {
        label: 'Tablets',
        slug: 'tablets',
        icon: '/images/tableIcons/cs-tabletIconSearch.svg',
    },
};

/** Operadores cuya página ya muestra la lista de suscripciones; el resto sigue en preparación. */
const SUBSCRIPTION_LIST_OPERATORS = ['ENTEL', 'EASYM2M', 'TELEFONICATECH', 'WHEREVER SE', 'WHEREVER DE'];

const isAmong = (operators, name) =>
    operators.some((operator) => operatorKey(operator) === operatorKey(name));

export function hasSubscriptionList(name) {
    return isAmong(SUBSCRIPTION_LIST_OPERATORS, name);
}

/**
 * Operadores que cobran solo por Stripe: sus suscripciones no tienen credenciales de Apio.
 * En ellos no hay embudo de Apio ni job de reintentos.
 */
const STRIPE_ONLY_OPERATORS = ['EASYM2M', 'TELEFONICATECH', 'WHEREVER SE', 'WHEREVER DE'];

export function usesApio(name) {
    return !isAmong(STRIPE_ONLY_OPERATORS, name);
}

/** Solo los operadores con marca registrada tienen página de detalle. */
export function hasOperatorDetail(name) {
    return brandedOperator(name) !== null;
}

/** "WHEREVER SE" → "wherever-se": el país queda aparte para que se lea en la URL. */
function operatorSlug(name) {
    const byCountry = /^(.*\S)\s+([A-Za-z]{2})$/.exec(name || '');
    return byCountry
        ? `${operatorKey(byCountry[1]).toLowerCase()}-${byCountry[2].toLowerCase()}`
        : operatorKey(name).toLowerCase();
}

export function operatorDetailPath(project, operatorName) {
    return `${SUBSCRIPTIONS_PATH}/${PRODUCTS[project].slug}/${operatorSlug(operatorName)}`;
}

/** Parámetros de la URL → producto y operador, o null si esa página no existe. */
export function parseOperatorDetail({ product, operator }) {
    const project = Object.keys(PRODUCTS).find((key) => PRODUCTS[key].slug === product);
    const operatorName = brandedOperator(operator);
    return project && operatorName ? { project, operatorName } : null;
}
